// const server = "http://localhost";
// const domain = "localhost";
// const port = 9666;
const serverImg = 'https://agroindustrias.nbg1.your-objectstorage.com/public';
const server = "https://apiagroindustrias.mansolutions.app";
const port = 443;
const domain = "agroindustrias.mansolutions.app";
export { server, port, domain, serverImg };
